export const JOURNEY_COVER_IMAGES: Record<string, string> = {
  STILL_WATERS: '/journeys/still-waters.webp',
  MORNING_FIRE: '/journeys/morning-fire.webp',
  NIGHT_TIDE: '/journeys/night-tide.webp',
  THE_SHARPENED_MIND: '/journeys/sharpened-mind.webp',
  ROOTS_OF_PRANA: '/journeys/roots-of-prana.webp',
  CENTER_GROUND: '/journeys/center-ground.webp',
  QUIET_FURNACE: '/journeys/quiet-furnace.webp',
  THE_SETTLING: '/journeys/the-settling.webp',
  FIVE_DIMENSIONS_OF_PRANAYAMA: '/journeys/five-dimensions-of-pranayama.webp',
};
